import { render } from "./CompanyLogoMobile.vue?vue&type=template&id=24823645"
import script from "./CompanyLogoMobile.vue?vue&type=script&lang=js"
export * from "./CompanyLogoMobile.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__